<template>

    <tr>
        <td>

            <v-tooltip bottom>

                <template v-slot:activator="{ on }">

                    <a target="_blank"
                       class="secondary-color"
                       v-on="on"
                       :href="`/app/bazisnet3#/master-data/clients/${ugyfel.ugyfazon}`"
                    >
                        {{
                          typeof ugyfel.otitulus === "string" && ugyfel.otitulus.length > 0
                              ? `${ugyfel.otitulus} ${ugyfel.nev}`
                              : ugyfel.nev
                        }}
                    </a>

                </template>

                <span> Ügyfél megnyitása ügyféltörzsben </span>

            </v-tooltip>

        </td>

        <td>{{ ugyfel.cim }}</td>

        <td>{{ ugyfel.ugyfnem === 3 ? ugyfel.anyanev : ugyfel.szulido }}</td>

        <td>{{ ugyfel.uzletkoto }}</td>

        <td class="text-center">

            <v-tooltip key="ugyfel-megbizas-feltoltve" bottom v-if="ugyfel.megbizasi">

                <template v-slot:activator="{on}">

                    <v-icon v-on="on" color="success"> check</v-icon>

                </template>

                <span>Az ügyfélhez van feltöltve aláírt teljeskörű megbízási szerződés. </span>

            </v-tooltip>
            <v-tooltip key="ugyfel-megbizas-uj-verzio" bottom
                       v-if="ugyfel.megbizasi && ugyfel.elerhetoFrissebbMegbizasi && hibridKotesElerheto()">

                <template v-slot:activator="{on}">

                    <v-icon v-on="on" color="error"> priority_high </v-icon>

                </template>

                <span>
                    Új alkuszi megállapodás verzió van a felületen, ezért küldje ki újra az ügyfelének elfogadásra!
                </span>

            </v-tooltip>

            <v-tooltip key="ugyfel-megbizas-nincs-feltoltve" bottom  v-if="!ugyfel.megbizasi">

                <template v-slot:activator="{on}">

                    <v-icon v-on="on" color="error"> close</v-icon>

                </template>

                <span>Az ügyfélhez nincs feltöltve aláírt teljeskörű megbízási szerződés. </span>

            </v-tooltip>

            <v-tooltip key="ugyfel-megbizas-kuldes"
                       bottom
                       v-if="(!ugyfel.megbizasi || ugyfel.elerhetoFrissebbMegbizasi)
                       && !sendingMegbizasi
                       && ugyfel.confirmation_date
                        && hibridKotesElerheto()
                        ">

                <template v-slot:activator="{on}">

                    <v-icon
                        v-on="on"
                        @click="sendMegbizasi()"
                    > send </v-icon>

                </template>

                <span> Megbízási szerződés küldése az ügyfél részére. </span>

            </v-tooltip>

            <v-progress-circular
                v-if="sendingMegbizasi"
                indeterminate
                color="secondary"
            >
            </v-progress-circular>

        </td>

        <td v-if="hibridKotesElerheto()">

            <v-layout row wrap justify-space-between align-center align-content-center>

                <v-flex md10 v-if="!editingEmailAddress">

                    {{ ugyfel.email }}

                </v-flex>

                <v-flex md10 v-else>

                    <v-text-field
                        :value="ugyfel.email"
                        @change="$emit('email-changed', $event)"
                    >

                    </v-text-field>

                </v-flex>

                <v-flex md2 v-if="!ugyfel.confirmation_date && !forceConfirmed">

                    <v-tooltip bottom  v-if="!editingEmailAddress">

                        <template
                            v-slot:activator="{ on }">

                            <v-icon
                                v-on="on"
                                @click="editingEmailAddress = !editingEmailAddress">
                                edit
                            </v-icon>

                        </template>

                        <span> Ügyfél e-mail-címének módosítása  </span>

                    </v-tooltip>

                    <v-tooltip bottom v-if="editingEmailAddress">

                        <template
                            v-slot:activator="{ on }">

                            <v-icon
                                v-on="on"
                                @click="() => {
                                    let msg = 'Az e-mail-cím csak a megerősítő e-mail kiküldésekor kerül mentésre!';
                                    editingEmailAddress = !editingEmailAddress;
                                    confirm({ message: msg });
                                }">
                                save
                            </v-icon>

                        </template>

                        <span> Ügyfél e-mail-címének módosítása  </span>

                    </v-tooltip>

                </v-flex>

            </v-layout>

        </td>

        <td class="text-center" v-if="hibridKotesElerheto()">

            <v-tooltip bottom v-if="ugyfel.confirmation_date || forceConfirmed">

                <template v-slot:activator="{on}">

                    <v-icon
                        v-on="on"
                        color="success"
                    >
                        check
                    </v-icon>

                </template>

                <span>Az ügyfél e-mail-címe meg van erősítve. </span>

            </v-tooltip>

            <template v-if="!ugyfel.confirmation_date && !forceConfirmed">

                <v-tooltip bottom>

                    <template v-slot:activator="{on}">

                        <v-icon v-on="on" color="error" > close</v-icon>

                    </template>

                    <span>Az ügyfél e-mail-címe nincs megerősítve. </span>

                </v-tooltip>

                <v-tooltip bottom v-if="!sending">

                    <template v-slot:activator="{ on }">

                        <v-icon
                            v-on="on"
                            @click="sendClientEmailConfirmationEmail(ugyfel)"> send
                        </v-icon>

                    </template>

                    <span> Megerősítő e-mail küldése </span>

                </v-tooltip>

                <v-progress-circular
                    v-if="sending"
                    indeterminate
                    color="secondary"
                >
                </v-progress-circular>

                <v-tooltip bottom v-if="kodosMegerositesElerheto">

                    <template v-slot:activator="{ on }">

                        <v-icon
                            v-on="on"
                            @click="confirmationCodeVisible = !confirmationCodeVisible"> edit
                        </v-icon>

                    </template>

                    <span> E-mail-cím megerősítő kód megadása </span>

                </v-tooltip>

                <v-layout
                    row wrap
                    justify-center
                    v-if="confirmationCodeVisible"
                >

                    <v-flex md4>

                        <v-text-field
                            persistent-hint
                            hint="Megerősítő kód"
                            v-model="clientEmailConfirmationCode">
                        </v-text-field>

                    </v-flex>

                    <v-flex align-self-center md3>

                        <v-btn
                            v-if="!confirming"
                            text
                            color="secondary"
                           @click="confirmClient()"
                        >
                            megerősít
                        </v-btn>
                        <v-progress-circular
                            v-if="confirming"
                            indeterminate
                            color="secondary"
                        >
                        </v-progress-circular>

                    </v-flex>

                </v-layout>

            </template>

        </td>

        <td class="text-center">

            <v-btn
                class="button"
                color="secondary"
                @click="selectUgyfel(ugyfel)">
                Betölt
            </v-btn>

        </td>

        <td class="text-center">

            <v-tooltip bottom>

                <template v-slot:activator="{ on }">

                    <v-icon
                        color="error"
                        v-on="on"
                        @click="$emit('delete-ugyfel', { ugyfel, index })"> delete
                    </v-icon>

                </template>

                <span> Ügyfél törlése </span>

            </v-tooltip>

        </td>

    </tr>

</template>

<script>
import ugyfeltorzsService from '../../services/UgyfeltorzsService';

export default {
    name: 'BnUgyfelKivalasztUgyfelRow',
    props: ['ugyfel', 'index', 'isHibrid', 'path'],
    computed: {
        kodosMegerositesElerheto() {
            return this.$store.getters.getBroker.ceg !== 307;
        },
    },
    data() {
        return {
            editingEmailAddress: false,
            confirmationCodeVisible: false,
            clientEmailConfirmationCode: null,
            notice: '',
            forceConfirmed: false,
            confirming: false,
            sending: false,
            sendingMegbizasi: false,
            ugyfelMegbizasiToConfirm: null,
            ugyfelEmailToConfirm: null,
        };
    },
    methods: {
        hibridKotesElerheto() {
            if (this.$store.getters.getBroker.ceg === 307 || this.$store.getters.getBroker.ceg === 1) {
                return true;
            }
            return false;
        },
        selectUgyfel(ugyfel) {
            if (this.path !== 'finanszirozo' && this.path !== 'tulajdonos') {
                this.$store.commit('setClientEmailConfirmed', !!this.ugyfel.confirmation_date);
            }
            if (this.isHibrid
                && !this.ugyfel.confirmation_date
                && this.hibridKotesElerheto()
                && this.path !== 'finanszirozo'
                && this.path !== 'tulajdonos'
            ) {
                this.confirm({
                    // eslint-disable-next-line no-useless-concat,max-len
                    message: 'A választott ügyfél email címe nincs megerősítve. A Betöltés utáni tarifálás hagyományos kötés lesz.\n' + 'Amennyiben hibrid kötést szeretne, úgy válassza ki újra az ügyfelet és küldje el az email cím megerősítő levelet, majd annak ügyfél általi elfogadása után frissítse a felületet',
                    okFn: () => {
                        this.$emit('select-ugyfel', ugyfel);
                        this.$store.commit('setHibrid', false);
                    },
                    okText: 'Rendben, hagyományosat kötök',
                    closeFn: () => {},
                    closeText: 'Vissza, kiküldöm a megerősítő emailt',
                    width: 800,
                });
            } else {
                this.$emit('select-ugyfel', ugyfel);
            }
        },
        sendClientEmailConfirmationEmail() {
            this.sending = true;
            this.ugyfelEmailToConfirm = this.ugyfel.ugyfazon;
            ugyfeltorzsService.sendConfirmationEmail(this.ugyfel, this.ugyfel.email).then(() => {
                this.confirm({
                    message: `Megerősítő e-mail-t elküldtük az ügyfél részére a(z) ${this.ugyfel.email} e-mail címre`,
                });
            }).catch(() => {}).finally(() => {
                this.sending = false;
            });
        },
        confirmClient() {
            this.confirming = true;
            ugyfeltorzsService.confirmClientEmail(this.ugyfel, this.clientEmailConfirmationCode).then(() => {
                this.confirmationCodeVisible = false;
                this.forceConfirmed = true;
                this.confirm({ message: 'Az ügyfél e-mail-címének megerősítése sikeres!' });
            }).catch(() => {}).finally(() => {
                this.confirming = false;
            });
        },
        sendMegbizasi() {
            this.sendingMegbizasi = true;
            this.ugyfelMegbizasiToConfirm = this.ugyfel.ugyfazon;
            ugyfeltorzsService.sendMegbizasi(this.ugyfel).then(() => {
                this.confirm({ message: 'A megbízási szeződést elküldtük az ügyfél részére!' });
            }).finally(() => {
                this.sendingMegbizasi = false;
            });
        },
    },
};
</script>

<style>
.secondary-color {
    color:  var(--v-secondary-base) !important;
}
</style>
